import { useVisibleT } from "@/lib/cms/cms-new-i18n";
import { cn } from "@/lib/utils";
import { Download } from "lucide-react";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Button, ButtonProps } from "../ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

const PrintButton = forwardRef<
  HTMLButtonElement,
  ButtonProps & {
    hideText?: boolean;
    iconSize?: number;
    iconColor?: string;
    disabled?: boolean;
  }
>(
  (
    {
      className,
      hideText = false,
      iconSize = 16,
      iconColor = "#64748B",
      disabled = false,
      ...props
    },
    ref,
  ) => {
    const { t } = useTranslation();
    const vt = useVisibleT();

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            ref={ref}
            variant="outline"
            className={cn("flex flex-row gap-2 items-center", className)}
            disabled={disabled}
            {...props}
          >
            <Download size={iconSize} color={iconColor} />
            {!hideText && t("singleArtworkPrintBtn")}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="top" variant="action" className="px-3">
          <span className="text-white text-sm font-medium">
            {vt(
              "bo.tooltip.printSelection",
              "Générer un PDF ou Word à partir de la sélection",
            )}
          </span>
        </TooltipContent>
      </Tooltip>
    );
  },
);

export default PrintButton;
